import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'datastatus'
})
export class DatastatusPipe implements PipeTransform {

  transform(value: string): string {

    if (!value) { // check if the value is null before performing any transformations
      return null;
    }

    if (value.toUpperCase().trim() === 'PUBLISHED') {
      return 'Bevestigd';
    }

    if (value.toUpperCase().trim() === 'CANCELLED') {
      return 'Geannuleerd';
    }

    if (value.toUpperCase().trim() === 'DELETED') {
      return 'Verwijderd';
    }

    if (value.toUpperCase().trim() === 'CONCEPT') {
      return 'In Optie';
    }

    return 'Status onbekend';

  }

}
